import React from 'react';

export default function PictoItalian40() {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_840_815)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M38.7661 32.3572C38.9561 32.5836 39.0361 32.8825 38.9848 33.1736C38.8474 33.9527 38.4165 34.8587 37.8231 35.5774C37.2429 36.2801 36.3388 37 35.1956 37H4.8044C3.66095 37 2.75679 36.28 2.17671 35.5772C1.58337 34.8584 1.15258 33.9525 1.01521 33.1737C0.963862 32.8826 1.04394 32.5837 1.23394 32.3572C1.42395 32.1308 1.7044 32 2.00001 32H38C38.2956 32 38.576 32.1308 38.7661 32.3572ZM38 33H2.00001C2.05365 33.3041 2.17234 33.6517 2.34341 34C2.83333 34.9974 3.75287 36 4.8044 36H35.1956C36.2469 36 37.1666 34.9975 37.6566 34C37.8277 33.6518 37.9464 33.3041 38 33Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.5 22.5C8.24421 22.5 3.5 26.807 3.5 32H2.5C2.5 26.193 7.75579 21.5 13.5 21.5V22.5Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.70992 27.6037C6.70449 28.9207 6 30.6913 6 32.5H5C5 30.4427 5.79551 28.4634 6.91508 26.9968C8.01954 25.5501 9.52413 24.5 11 24.5V25.5C9.97587 25.5 8.73046 26.2669 7.70992 27.6037Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23 18.5C15.5442 18.5 9.5 24.5442 9.5 32H8.5C8.5 23.9919 14.9919 17.5 23 17.5C31.0081 17.5 37.5 23.9919 37.5 32H36.5C36.5 24.5442 30.4558 18.5 23 18.5Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23 21.5C17.201 21.5 12.5 26.201 12.5 32H11.5C11.5 25.6487 16.6487 20.5 23 20.5C29.3513 20.5 34.5 25.6487 34.5 32H33.5C33.5 26.201 28.799 21.5 23 21.5Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23 24.5C18.8579 24.5 15.5 27.8579 15.5 32H14.5C14.5 27.3056 18.3056 23.5 23 23.5C27.6944 23.5 31.5 27.3056 31.5 32H30.5C30.5 27.8579 27.1421 24.5 23 24.5Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23 27.5C20.5147 27.5 18.5 29.5147 18.5 32H17.5C17.5 28.9624 19.9624 26.5 23 26.5C26.0376 26.5 28.5 28.9624 28.5 32H27.5C27.5 29.5147 25.4853 27.5 23 27.5Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.4287 1.74277C19.5708 1.97956 19.494 2.28669 19.2572 2.42876C18.8915 2.64824 18.3157 3.10635 17.836 3.73944C17.3577 4.37087 17 5.14222 17 6.00001C17 6.53331 17.131 6.91165 17.3171 7.2155C17.5103 7.53113 17.7741 7.78654 18.0845 8.06587C18.1236 8.10109 18.1638 8.13683 18.2048 8.17323C18.7793 8.68404 19.5 9.32488 19.5 10.5C19.5 11.1569 19.1787 11.7666 18.8216 12.1951C18.6392 12.4139 18.4324 12.6043 18.2227 12.7442C18.0271 12.8745 17.7707 13 17.5 13C17.2239 13 17 12.7762 17 12.5C17 12.2239 17.2239 12 17.5 12C17.4972 12 17.4958 12 17.4958 11.9998C17.4956 11.9986 17.5531 11.9887 17.668 11.9121C17.7864 11.8332 17.9233 11.7111 18.0534 11.5549C18.3213 11.2334 18.5 10.8431 18.5 10.5C18.5 9.78376 18.105 9.42882 17.4813 8.86832C17.4597 8.84886 17.4377 8.82914 17.4155 8.80916C17.1009 8.52599 16.7397 8.18765 16.4642 7.73765C16.1815 7.27588 16 6.71672 16 6.00001C16 4.85781 16.4756 3.87916 17.039 3.13559C17.601 2.39368 18.2752 1.85179 18.7428 1.57127C18.9795 1.42919 19.2867 1.50598 19.4287 1.74277Z"
          fill="#142138"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.8536 3.14645C22.0488 3.34171 22.0488 3.65829 21.8536 3.85355C21.815 3.89207 21.7748 3.9316 21.7333 3.97236C21.2144 4.48222 20.5 5.18416 20.5 6.5C20.5 7.28016 20.8588 7.6517 21.3536 8.14645C21.3587 8.1516 21.3639 8.15677 21.3691 8.16195C21.8718 8.66458 22.5 9.2926 22.5 10.5C22.5 11.6333 21.9 12.5 21 12.5C20.7239 12.5 20.5 12.2761 20.5 12C20.5 11.7239 20.7239 11.5 21 11.5C21.1 11.5 21.5 11.3667 21.5 10.5C21.5 9.71984 21.1412 9.3483 20.6464 8.85355L20.6309 8.83805C20.1282 8.33542 19.5 7.7074 19.5 6.5C19.5 4.75085 20.4978 3.77908 21.0273 3.26343C21.0704 3.22147 21.1104 3.18254 21.1464 3.14645C21.3417 2.95118 21.6583 2.95118 21.8536 3.14645Z"
          fill="#142138"
        />
      </g>
      <defs>
        <clipPath id="clip0_840_815">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
